import React from "react";
import {Redirect, Route} from "react-router-dom";
import {useAuth} from "contexts/AuthContext";
import {StyleDiv, StyleDivCenterChild} from "components/Common/StyleDiv";
import ActivityPageSkeleton from "components/Activity/ActivityPageSkeleton";
import AndroidNavigationBar from "components/Common/AndroidNavigationBar";

interface PrivateRouteProps {
  component: React.ComponentType<any>;
  [key: string]: any;
}

const PrivateRoute = ({component: Component, ...rest}: PrivateRouteProps) => {
  const {user, isAuthenticating} = useAuth();

  if (isAuthenticating)
    return (
      <StyleDiv width="100%" display="block" margin="0 auto">
        <AndroidNavigationBar title="Loading..." titleStyle={{fontWeight: "bold"}} />
        <StyleDivCenterChild marginRight="15px" marginLeft="20px" width="92%" height="100%">
          {<div style={{height: "75px"}} />}
          <ActivityPageSkeleton isWebview={true} />
        </StyleDivCenterChild>
      </StyleDiv>
    );

  return (
    <Route
      {...rest}
      render={(props) => (user ? <Component {...props} {...(rest.props || {})} /> : <Redirect to="/sign-in" />)}
    />
  );
};

export default PrivateRoute;
